import { styled } from '@material-ui/core';

import TiptapBlockquote from '@tiptap/extension-blockquote';
import {
  NodeViewContent,
  type NodeViewProps,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from '@tiptap/react';

import { CommentZone } from '@spotify/plugin-confidence-comments-react';

import { useBlockZoneId } from '../hooks';
import { blockIdAttribute } from '../utils';
import {
  BlockTypes,
  allBlocks,
  buildContentSchema,
  excludeBlocks,
} from './blockTypes';
import { tiptapBlockMarginBottom, tiptapBlockMarginTop } from './editorStyles';

const blockquoteContent = buildContentSchema(
  excludeBlocks(allBlocks, [
    BlockTypes.COLUMNS,
    BlockTypes.TABLE,
    BlockTypes.METRIC_TABLE,
  ]),
);

const StyledBlockquote = styled('blockquote')({
  margin: 0,
  marginBottom: tiptapBlockMarginBottom,
  marginTop: tiptapBlockMarginTop,
  marginRight: 'var(--bui-space-6)',
  padding: 'var(--bui-space-2) var(--bui-space-4)',
  borderLeft: '4px solid var(--bui-border)',
});

const BlockquoteComponent = ({ node, updateAttributes }: NodeViewProps) => {
  const { blockId } = node.attrs;
  const zoneId = useBlockZoneId('blockquote', blockId, updateAttributes);

  const content = (
    <StyledBlockquote>
      <NodeViewContent />
    </StyledBlockquote>
  );

  return (
    <NodeViewWrapper>
      {zoneId ? (
        <CommentZone id={zoneId} component="div">
          {content}
        </CommentZone>
      ) : (
        content
      )}
    </NodeViewWrapper>
  );
};

export const Blockquote = TiptapBlockquote.extend({
  content: blockquoteContent,

  addAttributes() {
    return {
      ...this.parent?.(),
      blockId: blockIdAttribute,
    };
  },

  addNodeView() {
    // eslint-disable-next-line new-cap
    return ReactNodeViewRenderer(BlockquoteComponent);
  },
});
